import { render, staticRenderFns } from "./GastoMedioPorClienteChart.vue?vue&type=template&id=09050016"
import script from "./GastoMedioPorClienteChart.vue?vue&type=script&lang=js"
export * from "./GastoMedioPorClienteChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports